/* src/app/common/components/breadcrumb-bar/breadcrumb-bar.component.scss */
.breadcrumb-bar {
  background-color: var(--bg-white);
  border-bottom: 1px solid var(--color-gray2);
  padding: 10px 0;
}
.breadcrumb-bar .breadcrumb-home {
  color: var(--color-primary);
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
}
.breadcrumb-bar .breadcrumb-sep {
  margin: 0 8px;
  color: var(--text-color);
  font-size: 13px;
}
.breadcrumb-bar .breadcrumb-current {
  font-weight: 700;
  font-size: 13px;
  color: var(--color-black);
}
/*# sourceMappingURL=breadcrumb-bar.component-2ORHTNXZ.css.map */
